import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=365e2bcc"
import script from "./Landing.js?vue&type=script&lang=js&external"
export * from "./Landing.js?vue&type=script&lang=js&external"
import style0 from "./Landing.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports